export default "__VITE_PUBLIC_ASSET__f8d648b9__"